import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=0ac49b30&scoped=true&"
import script from "./Entrance.vue?vue&type=script&lang=js&"
export * from "./Entrance.vue?vue&type=script&lang=js&"
import style0 from "./Entrance.vue?vue&type=style&index=0&id=0ac49b30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac49b30",
  null
  
)

export default component.exports